<template>
  <div v-if="hasError" class="error-boundary-container">
    <div class="error-boundary-circle">
      <q-icon name="warning" size="28px" :style="{ color: 'var(--oa-danger)' }" />
    </div>
    <h2 class="error-boundary-title">Algo salio mal</h2>
    <p class="error-boundary-subtitle">
      Hubo un error al cargar esta pagina. Podes intentar de nuevo o volver al inicio.
    </p>
    <div class="error-boundary-actions">
      <button class="error-boundary-btn-primary" @click="reset">
        Intentar de nuevo
      </button>
      <router-link to="/" class="error-boundary-btn-outline">
        Ir al inicio
      </router-link>
    </div>
  </div>
  <slot v-else />
</template>

<script setup lang="ts">
import { ref, onErrorCaptured } from 'vue';

const hasError = ref(false);
const errorMessage = ref('');

onErrorCaptured((err: Error) => {
  console.error('ErrorBoundary caught:', err);
  hasError.value = true;
  errorMessage.value = err.message || 'Error desconocido';
  return false; // prevent propagation
});

function reset() {
  hasError.value = false;
  errorMessage.value = '';
}
</script>

<style scoped>
.error-boundary-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  text-align: center;
  padding: 16px;
}

.error-boundary-circle {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(196, 90, 74, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.error-boundary-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--oa-text-primary);
  margin: 0 0 8px 0;
}

.error-boundary-subtitle {
  font-size: 0.875rem;
  color: var(--oa-text-secondary);
  margin: 0 0 24px 0;
  max-width: 400px;
  line-height: 1.5;
}

.error-boundary-actions {
  display: flex;
  gap: 12px;
}

.error-boundary-btn-primary {
  padding: 10px 20px;
  background: var(--oa-gold-full);
  color: var(--color-marble-cream);
  font-weight: 600;
  font-size: 0.875rem;
  border: none;
  border-radius: var(--oa-radius-xl);
  cursor: pointer;
  transition: background var(--oa-duration-normal) var(--oa-ease);
}

.error-boundary-btn-primary:hover {
  background: var(--oa-gold-bright);
}

.error-boundary-btn-outline {
  padding: 10px 20px;
  background: transparent;
  color: var(--oa-text-primary);
  font-weight: 500;
  font-size: 0.875rem;
  border: 1px solid var(--oa-border);
  border-radius: var(--oa-radius-xl);
  text-decoration: none;
  cursor: pointer;
  transition: background var(--oa-duration-normal) var(--oa-ease);
}

.error-boundary-btn-outline:hover {
  background: var(--oa-bg-2);
}
</style>
